export const base_url = window.origin
export const csrf = document.querySelector("meta[name='csrf-token']").getAttribute('content')
export const request_options = {
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrf
  }
}
